var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "plan_entry"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = { class: "title" };
const _hoisted_7 = { class: "bt_box" };
const _hoisted_8 = {
    key: 0,
    class: "lead text-margin"
};
const _hoisted_9 = {
    key: 1,
    class: "lead text-margin"
};
const _hoisted_10 = {
    id: "plan-modal",
    class: "modal type3 js-modal"
};
const _hoisted_11 = { class: "modal-content" };
const _hoisted_12 = { class: "close_bt" };
const _hoisted_13 = {
    key: 0,
    class: "pop"
};
const _hoisted_14 = {
    key: 0,
    class: "lead"
};
const _hoisted_15 = { class: "tab-wrap" };
const _hoisted_16 = ["value", "id"];
const _hoisted_17 = ["for"];
const _hoisted_18 = { class: "form-plan tab-content" };
const _hoisted_19 = { class: "plan-title" };
const _hoisted_20 = { class: "plan-main" };
const _hoisted_21 = { class: "plan-main-top" };
const _hoisted_22 = { class: "plan-money" };
const _hoisted_23 = {
    key: 0,
    class: "plan-add"
};
const _hoisted_24 = { class: "plan-article" };
const _hoisted_25 = { style: { "font-size": "1.8rem", "padding-bottom": "20px" } };
const _hoisted_26 = { class: "bt_box clear" };
const _hoisted_27 = { class: "modalBtn-area b2" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
    key: 1,
    class: "pop"
};
const _hoisted_30 = { class: "spinner-container" };
const _hoisted_31 = { class: "spinner" };
const _hoisted_32 = { key: 1 };
const _hoisted_33 = { class: "footerFixed" };
const _hoisted_34 = { class: "loading-container" };
const _hoisted_35 = { class: "spinner-container" };
const _hoisted_36 = { class: "spinner" };
import { inject, ref, reactive, watch, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import moment from 'moment';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import { PlanCategory } from '@util/Consts';
import ImageFrame from '@component/ImageFrame.vue';
import { isObjEmpty } from '@util/Common';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
const MSG_NONE = 0;
const MSG_CHANGE_PLAN = 1;
const MSG_CHANGE_PAID_PLAN = 2;
export default /*@__PURE__*/ _defineComponent({
    __name: 'plan_entry',
    props: {
        common: {},
        errors: {},
        plan: {},
        card_id: {},
        pre_order: {},
        plan_name: {},
        pre_order_plan_name: {},
        is_card_expire: { type: Boolean },
        next_plan_date: {},
        create_question_available: { type: Boolean },
        payment_intent_client_secret: {},
        redirect_status: {},
        auto_open_change: { type: Boolean },
        success: {}
    },
    setup(__props) {
        const props = __props;
        // 「変更」ボタン（jquery modal の modal_win）。auto_open_change のときにプログラムからクリックする
        const changeBtn = ref();
        let stripe = null;
        const auth_3ds_complete = ref('ready');
        const validate = reactive({ shot: false });
        const form = reactive({
            plan_id: props.plan.plan_id,
        });
        const close = ref();
        const options = ref([]);
        // ゲスト会員はフリープランへの変更不可（管理者操作のみ。仕様 No.30/34）
        // モーダルの選択肢からフリーを外し、初期選択も有料プランにする
        const isGuest = computed(() => { var _a; return ((_a = props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) === PlanCategory.GUEST_PLAN; });
        const selectableOptions = computed(() => options.value.filter(option => !(isGuest.value && option.id === PlanCategory.FREE_PLAN)));
        // モーダルを開いたとき／キャンセルしたときの初期選択
        const defaultPlanId = () => {
            var _a, _b;
            if (isGuest.value) {
                // ゲストはフリーを選べないので、選択可能な先頭の有料プラン
                return (_b = (_a = selectableOptions.value[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : PlanCategory.FREE_PLAN;
            }
            return props.plan.plan_id;
        };
        const nextDate = ref('');
        const msgType = ref(MSG_NONE);
        const showLoading = ref(false);
        const showNowPlan = computed(() => {
            var _a, _b;
            if (((_a = props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) === PlanCategory.GUEST_PLAN) {
                return 'ゲスト';
            }
            return (_b = props.plan_name) !== null && _b !== void 0 ? _b : '';
        });
        const showNextPlan = computed(() => {
            var _a, _b;
            if ((props === null || props === void 0 ? void 0 : props.pre_order) && ((_a = props === null || props === void 0 ? void 0 : props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id) !== ((_b = props.plan) === null || _b === void 0 ? void 0 : _b.plan_id)) {
                // pre_order_plan_nameが存在しない場合は「フリー」と表示
                const planName = (props === null || props === void 0 ? void 0 : props.pre_order_plan_name) || 'フリー';
                return `${nextDate.value}〜　${planName}に変更予定`;
            }
            return '';
        });
        watch(() => form.plan_id, value => {
            var _a, _b;
            const plan_id = (_b = (_a = props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) !== null && _b !== void 0 ? _b : PlanCategory.FREE_PLAN;
            if (value == PlanCategory.FREE_PLAN) {
                msgType.value = MSG_NONE;
            }
            else {
                // プランが変更されていた場合、元々がフリーか有料でメッセージ切り替え
                msgType.value =
                    plan_id === PlanCategory.FREE_PLAN || plan_id === PlanCategory.GUEST_PLAN
                        ? MSG_CHANGE_PAID_PLAN
                        : MSG_CHANGE_PLAN;
            }
        });
        // disable button to change for  preorder same plan
        const disabled = computed(() => {
            var _a;
            // ゲスト会員がフリーを選んだ状態（選択肢読み込み前など）では送信不可
            if (isGuest.value && form.plan_id === PlanCategory.FREE_PLAN) {
                return true;
            }
            return form.plan_id == ((_a = props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id);
        });
        const onClickCancel = () => {
            close.value.click();
            setTimeout(() => {
                var _a, _b;
                form.plan_id = (_b = (_a = props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id) !== null && _b !== void 0 ? _b : defaultPlanId();
                validate.shot = false;
            }, 1000);
        };
        const onClickOk = () => {
            // ゲスト会員のフリープラン変更は管理者操作のみ。画面からは送信しない
            if (isGuest.value && form.plan_id === PlanCategory.FREE_PLAN)
                return;
            const isFreeUser = ((props.plan.plan_id == PlanCategory.GUEST_PLAN || props.plan.plan_id == PlanCategory.FREE_PLAN) && (form.plan_id != PlanCategory.GUEST_PLAN && form.plan_id != PlanCategory.FREE_PLAN));
            if ((props === null || props === void 0 ? void 0 : props.card_id) && isFreeUser) {
                if (form.plan_id == PlanCategory.FREE_PLAN)
                    return;
                const message = '有料プランを選択すると即時課金されますがよろしいですか？';
                if (!window.confirm(message))
                    return;
            }
            showLoading.value = true;
            Inertia.post(route('plan.update'), { plan_id: form.plan_id }, {
                onSuccess: () => {
                    close.value.click();
                    showLoading.value = false;
                },
                onError: () => {
                    validate.shot = true;
                    showLoading.value = false;
                    swal({
                        title: "決済失敗",
                        text: "クレジットカード決済に失敗しました。\nプランは変更されていません。\n\n必要により別カードの登録をご検討ください。",
                        icon: "warning",
                        buttons: {
                            ok: {
                                text: "OK",
                                className: "timeout-ok-btn",
                            },
                        },
                    }).then((value) => {
                        if (value) {
                            close.value.click();
                        }
                    });
                },
            });
        };
        const onClickGotoPaymentPage = () => {
            Inertia.get(route('payment.show'));
        };
        const onClickPlanModel = () => {
            if (form.plan_id !== PlanCategory.FREE_PLAN && form.plan_id !== PlanCategory.GUEST_PLAN) {
                msgType.value = MSG_CHANGE_PLAN;
            }
        };
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        const pollPaymentStatus = (stripeInstance, clientSecret) => __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < 10; i++) {
                yield sleep(1000);
                const { paymentIntent } = yield stripeInstance.retrievePaymentIntent(clientSecret);
                if (paymentIntent.status === 'succeeded') {
                    return 'succeeded';
                }
                if (paymentIntent.status === 'payment_failed' ||
                    paymentIntent.status === 'requires_payment_method') {
                    return 'payment_failed';
                }
            }
            return 'timeout';
        });
        // 3DS 成功時。プランの DB 更新は Stripe の Webhook（payment_intent.succeeded）で行われるため、
        // ブラウザが戻ってきた時点ではまだ旧プランのことがある。待てばよいことを伝え、OK で再読込する
        const handlePaymentSuccess = () => {
            swal({
                title: '完了',
                text: 'プラン変更が完了しました。\nプランの更新には少し時間がかかる場合があります。',
                icon: 'success',
                buttons: {
                    ok: {
                        text: 'OK',
                        className: 'timeout-ok-btn',
                    },
                },
            }).then(() => {
                window.location.href = route('plan.show');
            });
        };
        const handlePaymentFailed = (message) => {
            swal({
                title: '決済失敗',
                text: message,
                icon: 'warning',
                buttons: {
                    ok: {
                        text: 'OK',
                        className: 'timeout-ok-btn',
                    },
                },
            }).then(() => {
                window.location.href = route('plan.show');
            });
        };
        const handlePaymentTimeout = (message) => {
            swal({
                title: '決済処理中',
                text: message,
                icon: 'info',
                buttons: {
                    ok: {
                        text: 'OK',
                        className: 'timeout-ok-btn',
                    },
                },
            }).then(() => {
                window.location.href = route('plan.show');
            });
        };
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const publishableKey = inject('stripePublicKey', '');
            let stripeInstance = null;
            if (publishableKey && typeof publishableKey === 'string') {
                stripeInstance = yield loadStripe(publishableKey);
                if (!stripeInstance) {
                    console.error('Failed to load Stripe');
                }
            }
            else {
                console.error('Stripe API key is not available or invalid type');
            }
            // Check for 3DS2 return
            // PlanController::show は URL の payment_intent_client_secret / redirect_status を
            // セッション flash に退避してクリーンな /plan にリダイレクトするので、URL ではなく props から受け取る
            //（URL に残っている場合も念のため見る）
            const params = new URLSearchParams(window.location.search);
            const clientSecret = props.payment_intent_client_secret || params.get('payment_intent_client_secret');
            const redirectStatus = props.redirect_status || params.get('redirect_status');
            if (clientSecret && stripeInstance) {
                auth_3ds_complete.value = 'loading';
                try {
                    const { paymentIntent } = yield stripeInstance.retrievePaymentIntent(clientSecret);
                    if (redirectStatus === 'failed' || paymentIntent.status === 'requires_payment_method') {
                        // 3DS2 failed or cancelled
                        auth_3ds_complete.value = 'ready';
                        handlePaymentFailed('3DS2認証に失敗しました。\nプランは変更されていません。\n\n別のカードでの登録をご検討ください。');
                        return;
                    }
                    if (paymentIntent.status === 'succeeded') {
                        // Success
                        auth_3ds_complete.value = 'ready';
                        handlePaymentSuccess();
                        return;
                    }
                    if (paymentIntent.status === 'processing') {
                        // Processing - poll for status
                        const finalStatus = yield pollPaymentStatus(stripeInstance, clientSecret);
                        auth_3ds_complete.value = 'ready';
                        if (finalStatus === 'succeeded') {
                            handlePaymentSuccess();
                        }
                        else if (finalStatus === 'payment_failed') {
                            handlePaymentFailed('決済に失敗しました。\nプランは変更されていません。\n\n別のカードでの登録をご検討ください。');
                        }
                        else {
                            handlePaymentTimeout('決済処理に時間がかかっています。\nプランの変更状態については、しばらく経ってからマイページをご確認ください。');
                        }
                        return;
                    }
                    // requires_action（3DS 画面から戻るボタン等で未完了のまま戻った）など、上記以外は未完了扱い
                    auth_3ds_complete.value = 'ready';
                    handlePaymentFailed('3DS2認証が完了しませんでした。\nプランは変更されていません。\n\nもう一度お試しいただくか、別のカードでの登録をご検討ください。');
                    return;
                }
                catch (error) {
                    console.error('Error checking payment status:', error);
                    auth_3ds_complete.value = 'ready';
                    handlePaymentFailed('決済状態の確認中にエラーが発生しました。\nプランは変更されていません。');
                    return;
                }
            }
            auth_3ds_complete.value = 'ready';
            // 成功メッセージを表示
            if (props.success) {
                swal({
                    title: "完了",
                    text: props.success,
                    icon: "success",
                    buttons: {
                        ok: {
                            text: "OK",
                            className: "timeout-ok-btn",
                        },
                    },
                });
            }
            validate.shot = isObjEmpty(props.errors);
            form.plan_id = (_b = (_a = props.pre_order) === null || _a === void 0 ? void 0 : _a.plan_id) !== null && _b !== void 0 ? _b : defaultPlanId();
            // 適用開始日はサーバ側で算出した値を使う（未払いなら今月 1 日、支払い済みなら翌月 1 日）
            nextDate.value = (_c = props.next_plan_date) !== null && _c !== void 0 ? _c : moment(new Date()).add(1, 'months').startOf('month').format('YYYY年MM月DD日');
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
                // 支払方法登録完了の「料金プラン変更に戻る」から来た場合は、「変更」を押した状態（プラン選択モーダル）で開始
                // （カードが有効なときだけ「変更」ボタンが存在する）
                if (props.auto_open_change && changeBtn.value) {
                    changeBtn.value.click();
                }
            });
        }));
        onBeforeMount(() => {
            axios.get(route('plans')).then(response => {
                var _a, _b, _c;
                options.value = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : [];
                // ゲスト会員は選択肢の読み込み後に初期選択を有料プランへ寄せる
                if (isGuest.value) {
                    form.plan_id = (_c = (_b = props.pre_order) === null || _b === void 0 ? void 0 : _b.plan_id) !== null && _c !== void 0 ? _c : defaultPlanId();
                }
            }).catch(error => {
                console.error('Failed to load plans:', error);
                options.value = [];
            });
        });
        return (_ctx, _cache) => {
            var _a;
            return (auth_3ds_complete.value !== 'loading')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[5] || (_cache[5] = _createElementVNode("h2", null, "料金プラン変更", -1)),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("form", null, [
                                        _createElementVNode("dl", null, [
                                            _cache[1] || (_cache[1] = _createElementVNode("dt", null, "料金プラン", -1)),
                                            _createElementVNode("dd", null, [
                                                _createElementVNode("p", _hoisted_6, _toDisplayString(showNowPlan.value), 1),
                                                _createTextVNode(" " + _toDisplayString(showNextPlan.value), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            (!(props === null || props === void 0 ? void 0 : props.card_id) || props.is_card_expire)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (!(props === null || props === void 0 ? void 0 : props.card_id))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 有料プランへの変更は支払方法を先に登録してください。 "))
                                                        : _createCommentVNode("", true),
                                                    (props === null || props === void 0 ? void 0 : props.is_card_expire)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                                            _cache[2] || (_cache[2] = _createTextVNode(" クレジットカードの有効期限が切れています。")),
                                                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                                            (((_a = props === null || props === void 0 ? void 0 : props.plan) === null || _a === void 0 ? void 0 : _a.plan_id) !== 1)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode("もう一度支払い方法登録をお願い致します。")
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_unref(Link), {
                                                        href: _ctx.route('payment.show', { plan: true }),
                                                        class: "bt_change modal_win"
                                                    }, {
                                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                            _createTextVNode(" 支払方法登録 ")
                                                        ])),
                                                        _: 1,
                                                        __: [4]
                                                    }, 8, ["href"])
                                                ], 64))
                                                : (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    ref_key: "changeBtn",
                                                    ref: changeBtn,
                                                    class: "bt_change modal_win",
                                                    "data-target": "plan-modal",
                                                    onClick: onClickPlanModel
                                                }, "変更", 512))
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("form", null, [
                            _createElementVNode("div", _hoisted_10, [
                                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-bg" }, null, -1)),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(ImageFrame, {
                                            src: "images/common/i_bt_close.svg",
                                            class: "bt_modal_close",
                                            onClick: onClickCancel
                                        })
                                    ]),
                                    (!showLoading.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _cache[16] || (_cache[16] = _createElementVNode("h2", null, "料金プラン変更", -1)),
                                            _cache[17] || (_cache[17] = _createElementVNode("h3", null, "料金プランをお選びください", -1)),
                                            (isGuest.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " ※ゲスト会員はフリープランへの変更はできません。有料プランへの変更のみ可能です。 "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_15, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableOptions.value, (option, index) => {
                                                    var _a, _b, _c, _d, _e;
                                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.plan_id) = $event)),
                                                            value: option.id,
                                                            id: `TAB-${index}`,
                                                            type: "radio",
                                                            name: "TAB",
                                                            class: "tab-switch"
                                                        }, null, 8, _hoisted_16), [
                                                            [_vModelRadio, form.plan_id]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            class: "tab-label",
                                                            for: `TAB-${index}`
                                                        }, _toDisplayString(option.name), 9, _hoisted_17),
                                                        _createElementVNode("div", _hoisted_18, [
                                                            _createElementVNode("p", _hoisted_19, _toDisplayString(`${option.name}プラン`), 1),
                                                            _createElementVNode("div", _hoisted_20, [
                                                                (option.id !== _unref(PlanCategory).FREE_PLAN)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        _createElementVNode("div", _hoisted_21, [
                                                                            _cache[6] || (_cache[6] = _createElementVNode("p", null, "基本料金(月額)", -1)),
                                                                            _createElementVNode("p", null, "(相談" + _toDisplayString((_a = option === null || option === void 0 ? void 0 : option.monthly_question_count) !== null && _a !== void 0 ? _a : 0) + "件以内/月)", 1)
                                                                        ]),
                                                                        _createElementVNode("p", _hoisted_22, [
                                                                            _createTextVNode(_toDisplayString((_c = ((_b = option === null || option === void 0 ? void 0 : option.monthly_amount) !== null && _b !== void 0 ? _b : 0)) === null || _c === void 0 ? void 0 : _c.toLocaleString()), 1),
                                                                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "plan-type" }, "円(税込)", -1))
                                                                        ])
                                                                    ], 64))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "plan-main-top" }, [
                                                                            _createElementVNode("p", null, "基本料金(月額)")
                                                                        ], -1)),
                                                                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "plan-money" }, [
                                                                            _createTextVNode(" 無料 "),
                                                                            _createElementVNode("span", { class: "plan-type" }, "(相談は不可)")
                                                                        ], -1))
                                                                    ], 64))
                                                            ]),
                                                            (option.is_allowed_additional_question)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                    _cache[10] || (_cache[10] = _createElementVNode("p", null, "追加相談", -1)),
                                                                    _createElementVNode("p", null, _toDisplayString((_e = ((_d = option.additional_question_amount) !== null && _d !== void 0 ? _d : 0)) === null || _e === void 0 ? void 0 : _e.toLocaleString()) + "円 / 件(税込) ", 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (msgType.value === MSG_CHANGE_PLAN)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createElementVNode("div", _hoisted_24, [
                                                                        _createElementVNode("div", _hoisted_25, [
                                                                            _cache[11] || (_cache[11] = _createElementVNode("span", { style: { "padding-right": "30px" } }, "変更開始日", -1)),
                                                                            _createElementVNode("span", null, _toDisplayString(nextDate.value) + "〜", 1)
                                                                        ]),
                                                                        _cache[12] || (_cache[12] = _createElementVNode("p", null, "※料金プランの変更は、翌月１日分から変更適用となります。", -1))
                                                                    ]),
                                                                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "plan-alart" }, " ※この変更適用後に、キャンセルすることはできません。 ", -1))
                                                                ], 64))
                                                                : (msgType.value === MSG_CHANGE_PAID_PLAN)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "plan-article" }, [
                                                                            _createElementVNode("p", null, [
                                                                                _createTextVNode(" ※日割りできないので、初月の基本料金は、申込日に応じて次の対応とさせて頂きます。"),
                                                                                _createElementVNode("br"),
                                                                                _createTextVNode(" 申込日が1～15日：基本料金を全額支払い（質問チケットは基本と同数）"),
                                                                                _createElementVNode("br"),
                                                                                _createTextVNode(" 申込日が16～末日：基本料金を半額支払い（質問チケットは基本の半数） ")
                                                                            ])
                                                                        ], -1)),
                                                                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "plan-alart" }, "※このお申込後に、キャンセルすることはできません。", -1))
                                                                    ], 64))
                                                                    : _createCommentVNode("", true)
                                                        ])
                                                    ], 64));
                                                }), 256))
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("ul", _hoisted_27, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("p", {
                                                            class: "bt_modal_close bt_clear",
                                                            onClick: onClickCancel
                                                        }, "キャンセル")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "bt_ok",
                                                            onClick: onClickOk,
                                                            disabled: disabled.value
                                                        }, " OK ", 8, _hoisted_28)
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                                                ]),
                                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "message-box" }, [
                                                    _createElementVNode("p", null, [
                                                        _createElementVNode("strong", null, "現在決済処理中です")
                                                    ]),
                                                    _createElementVNode("p", null, "ボタンを押したり移動したりせず、このまましばらくお待ちください。処理が完了したら自動的に画面が変わります。")
                                                ], -1))
                                            ])
                                        ])),
                                    _createElementVNode("p", {
                                        class: "bt_modal_close",
                                        ref_key: "close",
                                        ref: close,
                                        style: { "display": "none" }
                                    }, null, 512)
                                ])
                            ])
                        ]),
                        _createVNode(footerVue)
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                    _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                                ]),
                                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "message-box" }, [
                                    _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, "決済状態を確認中です")
                                    ]),
                                    _createElementVNode("p", null, "しばらくお待ちください...")
                                ], -1))
                            ])
                        ]),
                        _createVNode(footerVue)
                    ])
                ]));
        };
    }
});
